import React from 'react';
import { useMaintenanceMode } from '../contexts/MaintenanceContext';
import AdvancedMaintenanceMode from './AdvancedMaintenanceMode';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
  allowRefresh?: boolean;
  showScheduleInfo?: boolean;
  showMaintenanceType?: boolean;
  customActions?: React.ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({
  children,
  allowRefresh = true,
  showScheduleInfo = true,
  showMaintenanceType = true,
  customActions
}) => {
  const { isMaintenanceActive } = useMaintenanceMode();

  /* Si el mantenimiento está activo, mostrar la pantalla de mantenimiento */
  if (isMaintenanceActive) {
    return (
      <AdvancedMaintenanceMode
        allowRefresh={allowRefresh}
        showScheduleInfo={showScheduleInfo}
        showMaintenanceType={showMaintenanceType}
        customActions={customActions}
      />
    );
  }

  /* Si no hay mantenimiento, renderizar los hijos normalmente */
  return <>{children}</>;
};

export default MaintenanceWrapper;
